module.exports = __webpack_public_path__ + "img/grade-4.c87cdd31.png";